<template>
    <div id="VehicleMasterList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name"><div class="page-title">Equipment Master</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="web-action-btn">
                        <div class="btn-groups text-right">
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                                <i class="fp-export"></i> Export
                            </a>

                        </div>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li><a href="javascript:void(0)" class="" v-on:click="exportReports()">Export</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-lists">
                        <div v-if="availabilityFromDate != null" class="asset-filter-section form-row row-cols-md-1 row-cols-1">
                            <div class="col form-group">
                                <p class="filter-title">Available assets list for the selected filters.</p>
                                <div class="asset-filter">
                                    <p> <i class="fp-calendar"></i> <span> {{availabilityFromDate}} To {{availabilityToDate}} </span> </p>
                                </div>
                                <div v-if="availabilityLocation != ''" class="asset-filter">
                                    <p> <i class="fp-placeholder"></i> <span> {{availabilityLocation.text}} </span> </p>
                                </div>
                                <div v-if="availabilityAssetType != ''" class="asset-filter">
                                    <p> <i class="fp-rental"></i> <span> {{availabilityAssetType.text}} </span> </p>
                                </div>
                                <div class="asset-filter-close">
                                    <p> <a href="javascript:void(0)" v-on:click.prevent="removeAvailabilityFilter"> <i class="fp-close"></i> </a> </p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'assetReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                            <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'assetReport'" :position="'top'">
                                </custom-pagination>


                                <!-- <vue-good-table
                                        ref="listVehicleTable"
                                        mode="remote"
                                        title="Asset"
                                        @on-page-change="onPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        :totalRows="totalRecords"
                                        :columns="userColumns"
                                        :rows="rows"
                                        @on-select-all="onSelectAll"
                                        :pagination-options="{
                                            enabled: false,
                                            position: 'both',
                                            setCurrentPage:listCurrentPage,
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :search-options="{
                                            enabled: false,
                                        }"
                                        :sort-options="{
                                            enabled: true,
                                            initialSortBy: {field: 'unit_no', type: 'asc'}
                                        }"
                                >

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdateAsset">
                                                    <router-link title="Edit Asset" class="fp-edit mr-3" v-bind:to="{name: 'AssetEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else-if="props.column.field == 'unit_no' && canViewAsset === true">
                                                <router-link title="View Asset Details" class="color-blue"  v-bind:to="{name: 'AssetView',params:{id:props.row.id}}">{{props.row.unit_no}}</router-link>
                                            </div>
                                            <div v-else-if="props.column.field == 'list_in'">
                                                <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template> -->
                                    <!-- <div slot="selected-row-actions"> -->
                                        <!-- commented delete button because asset is used in other modules also -->
                                        <!-- <button v-if="canDeleteAsset" id="deleteGroupBtn" v-on:click.prevent="VehicleDelete" class="btn btn-danger">Delete</button> -->
                                        <!-- <button v-if="recallMode && !programMode" id="recallBtn" v-on:click.prevent="openRecallModal" class="btn btn-primary">Add Asset To Recall</button>
                                        <button v-if="programMode" id="recallBtn" v-on:click.prevent="addAssetToProgram" class="btn btn-primary">Add Asset To Program</button>
                                    </div> -->
                                <!-- </vue-good-table> -->
                                <div class="vgt-responsive">
                                    <v-table :data="rows" :class="'vgt-table bordered'" :hideSortIcons="true">
                                        <thead slot="head">
                                        <template v-for="(col,ind) in userColumns">
                                            <template v-if="col.sortable == false">
                                            <th :key="'col_'+ind" :id="col.field" v-show="!col.hidden">{{ col.label }}</th>
                                            </template>
                                            <template v-else>
                                            <th :key="'col_'+ind" :id="col.field" class="sorting" @click="onSortChangeReports($event)" v-show="!col.hidden">{{ col.label }}</th>
                                            </template>
                                        </template>
                                        </thead>
                                        <tbody slot="body" slot-scope="{displayData}">
                                            <tr v-for="row in displayData">
                                            <template v-for="(col,ind1) in userColumns">
                                                <td :key="ind1" v-show="!col.hidden">{{ row[col.field] }}</td>
                                            </template>
                                            </tr>
                                        </tbody>
                                    </v-table>
                                </div>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                            </section>
                        </div>
                        <div class="modal fade add-extra-charge-popup" id="recallModal" ref="recallModal" data-backdrop="static" data-keyboard="false" aria-labelledby="recallModal" aria-hidden="true">
                                    <div class="modal-dialog modal-md" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="myModal1">Recall Asset</h5>
                                            </div>
                                            <div class="modal-body">
                                                <form autocomplete="off" id="SelectDates" class="addinspectionForm">
                                                    <div class="form-row row-cols-md-1 row-cols-1">
                                                        <div class="col form-group">
                                                            <label>Recall:</label>
                                                            <v-select v-model="recalls" :options="recallArr" label="text" name="recall"
                                                                placeholder="Recall" id="recall" class="custom-vselect">
                                                            </v-select>
                                                            <span class="field-error">{{errorDetails}}</span>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div class="modal-footer">
                                                <button class="btn btn-primary" id="addRecallAssetBtn" v-on:click="addRecallAsset()">
                                                    <i class="fp-submit"></i> {{submitBtnText}}
                                                </button>
                                                <button type="button" class="btn btn-tertiary" id="cancelRecallAssetBtn" data-dismiss="modal">
                                                    <i class="fp-close"></i> Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import EventBus from "./../event-bus";
    import Vue from "vue";




    //
    //
    //

    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    import SmartTable from 'vuejs-smart-table'
    Vue.use(SmartTable)

    export default {
        name: "VehicleList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Equipment Master List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            pageTitle:"Equipment Master",
            hideButton: false,
            availabilityFromDate:null,
            availabilityToDate:null,
            availabilityLocation:"",
            availabilityAssetType:"",
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            canViewAsset:true,
            userColumns:[],
            columns: [
                //  {
                //     label: 'Actions',
                //     field: 'action',
                //     sortable: false,
                //     hidden:false,
                // },
                {
                    label: 'Unit Number',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    width:'90px',
                    html:true
                },
                {
                    label: 'Unit Description',
                    field: 'name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    width:'90px',
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Facility Code',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Facility Description',
                    field: 'location_desc',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Region Code',
                    field: 'region_code',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Region Description',
                    field: 'region_description',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Equipment Type',
                    field: 'asset_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Equipment Type Description',
                    field: 'asset_type_desc',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Purchase Date',
                    field: 'purchase_date',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                },
                {
                    label: 'Date In Service',
                    field: 'date_in_service',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                },
                {
                    label: 'Year',
                    field: 'year',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Meter 1',
                    field: 'section_code1',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Meter 1 Desc',
                    field: 'section_name1',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Meter 1 Date',
                    field: 'reading_date1',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Meter 1 Current',
                    field: 'reading1',
                    filterable: false,
                    type: 'number',
                    fpFieldType:"integer",
                    hidden:false,
                    sortable:false
                },
                 {
                    label: 'Meter 1 LTD',
                    field: 'ltd_reading1',
                    filterable: false,
                    type: 'number',
                    fpFieldType:"integer",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Meter 1 UOM Desc',
                    field: 'uom1',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Meter 2',
                    field: 'section_code2',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Meter 2 Desc',
                    field: 'section_name2',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Meter 2 Date',
                    field: 'reading_date2',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Meter 2 Current',
                    field: 'reading2',
                    filterable: false,
                    type: 'number',
                    fpFieldType:"integer",
                    hidden:false,
                    sortable:false
                },
                 {
                    label: 'Meter 2 LTD',
                    field: 'ltd_reading2',
                    filterable: false,
                    type: 'number',
                    fpFieldType:"integer",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Meter 2 UOM Desc',
                    field: 'uom2',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Meter 3',
                    field: 'section_code3',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Meter 3 Desc',
                    field: 'section_name3',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Meter 3 Date',
                    field: 'reading_date3',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Meter 3 Current',
                    field: 'reading3',
                    filterable: false,
                    type: 'number',
                    fpFieldType:"integer",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Meter 3 LTD',
                    field: 'ltd_reading3',
                    filterable: false,
                    fpFieldType:"integer",
                    type: 'number',
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Meter 3 UOM Desc',
                    field: 'uom3',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Ownership',
                    field: 'ownership',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'GVW',
                    field: 'gross_weight',
                    filterable: true,
                    type: 'number',
                    fpFieldType:"integer",
                    hidden:false,
                },
                {
                    label: 'Tare',
                    field: 'tare_weight',
                    filterable: true,
                    fpFieldType:"integer",
                    type:'number',
                    hidden:false,
                },
                {
                    label: 'UOM',
                    field: 'uom',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Serial Number',
                    field: 'vin',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },

                {
                    label: 'Equipment Group',
                    field: 'asset_group',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Manufacturer',
                    field: 'manufacturer_code',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Model',
                    field: 'model',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Pool',
                    field: 'asset_pool',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: "Company Code",
                    field: "company_code",
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "#company", // placeholder for filter input
                      filterValue: "", // initial populated value for this filter
                      filterDropdownItems : ['000', '001', '002'], //dropdown (with selected values) instead of text input
                      trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: "Customer Number",
                    field: "customer_number",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: "Customer Suffix",
                    field: "customer_suffix",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: "Customer Name",
                    field: "customer_name",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Parent Unit Number',
                    field: 'paren_unit_no',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    width:'90px',
                    sortable:false,
                    html:true
                },
                {
                    label: 'Months In Service',
                    field: 'months',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Disposal Date',
                    field: 'disposal_dt',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                },
                {
                    label: "Super Type",
                    field: "super_type",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Super Type Description",
                    field: "super_type_desc",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Currently OOS (Y/N)?',
                    field: 'currently_wo',
                    fpFieldType:"option",
                    // sortable: false,
                    filterable: true,
                    hidden:false,
                    width:'90px',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "OOS", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Y','N'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                  label: 'On Sales List (Y/N)?',
                  field: 'on_sale',
                  hidden:false,
                  fpFieldType:"option",
                  filterable: true,
                  // sortable: false,
                  filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "All", // placeholder for filter input
                      filterDropdownItems: ['Y','N'],
                      filterValue: '', // initial populated value for this filter
                      trigger: "enter", //only trigger on enter not on keyup
                  },
                },
                 {
                    label: 'Purchase Price',
                    field: 'price',
                    filterable: true,
                    type: 'number',
                    fpFieldType:"integer",
                    hidden:false,
                },
                {
                    label: "User Defined Status Code",
                    field: "user_status_code",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "User Defined Sts Code Description",
                    field: "user_status_code_desc",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Parking Location",
                    field: "parking_loc",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Parking Location Description",
                    field: "parking_loc_desc",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Driver",
                    field: "driver",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Driver Name",
                    field: "driver_name",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Customer Alias Unit Number",
                    field: "cust_alias_unit_no",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Equipment Comments",
                    field: "equip_comments",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Current Maintenance Source Effective Date',
                    field: 'main_effec_date',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: "Current Maintenance Source",
                    field: "main_source",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Current Maintenance Source Description",
                    field: "main_source_desc",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Maintenance Source Vendor",
                    field: "main_source_vendor",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Maintenance Source Vendor Name",
                    field: "main_source_vendor_name",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Original Unit Number",
                    field: "original_unit_number",
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Pool Assignment Date',
                    field: 'assign_date',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                },


            ],
            rows: [],
            totalRecords: 0,
            canDeleteAsset: false,
            loading:false,
            canAddAsset:false,
            canUpdateAsset:false,
            accessCheckAvailability:false,
            selectedFile:"",
            recallMode:false,
            errorDetails:'',
            recalls:'',
            recallArr:[],
            assetRowCheckbox:false,
            action:"list",
            submitBtnText:"Submit",
            pageKey:"_vehicle_list_",
            programMode:false,
            batchProcess:0,
            batchNum:"",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'equipment_master') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_asset') {
                            self.canDeleteAsset = true;
                        }
                        if (permissions[i].name == 'add_asset') {
                            self.canAddAsset = true;
                            self.canUpdateAsset = true;
                        }
                        if (permissions[i].name == 'view_asset') {
                            self.canViewAsset = true;
                        }

                        if (permissions[i].name == 'check_asset_availability') {
                            self.accessCheckAvailability = true;
                        }
                        if (permissions[i].name == 'add_asset_to_recall') {
                            self.recallMode = true;
                        }
                        //row-selection checkbox
                        if (permissions[i].name == 'delete_asset' || permissions[i].name == 'add_asset_to_recall') {
                           if(self.$route.query.flag == 'assetReport'){
                              self.assetRowCheckbox = false;
                          } else{
                              self.assetRowCheckbox = true;
                          }

                        }
                    }
                }

            }
        },
        created: function() {

        },

        mounted: function() {

            var self = this;

            //self.loadList();
            self.getPermissions();

            if(self.$route.query.flag == 'assetReport'){
              self.hideButton = true;
              self.pageTitle = "Equipment Master";
              for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'action'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
              }
            }


            self.availabilityFromDate = localStorage.getItem("availabilityFromDate");
            self.availabilityToDate = localStorage.getItem("availabilityToDate");
            if ( localStorage.getItem("availabilityLocation") != null ) {
                self.availabilityLocation = JSON.parse(localStorage.getItem("availabilityLocation"));
            }
            if ( localStorage.getItem("availabilityAssetType") != null ) {
                self.availabilityAssetType = JSON.parse(localStorage.getItem("availabilityAssetType"));
            }

            // if(self.$route.query.from == 'recall'){
            //     self.recallMode = true;
            // }
            if (self.$route.query.from && self.$route.query.from == 'program'){
                self.programMode = true;
            }

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listVehicleTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['listVehicleTable'].selectedRows;
                // console.log(rowData);
            },
            // exportReports: function() {
            //     EventBus.$emit("clearSelection", false);
            //     var self = this;
            //     this.action = "export";
            //     this.loadList();
            // },
            removeAvailabilityFilter() {

                var self = this;

                self.availabilityFromDate = null;
                self.availabilityToDate = null;
                self.availabilityLocation = "";
                self.availabilityAssetType = "";


                self.serverParams.columnFilters.availabilityFromDate = "";
                self.serverParams.columnFilters.availabilityToDate = "";
                self.serverParams.columnFilters.availabilityAssetTypeId = "";
                self.serverParams.columnFilters.availabilityLocationId = "";


                //remove localstorage data
                localStorage.removeItem('availabilityFromDate');
                localStorage.removeItem('availabilityToDate');
                localStorage.removeItem('availabilityLocation');
                localStorage.removeItem('availabilityAssetType');

                this.loadList();
            },

            loadList() {

                var self = this;
                self.loading = true;

                //self.serverParams.columnFilters = params;

                var selectedRows = [];

                //because on first load list not initialize
                // var data = this.$refs['listVehicleTable'].selectedRows;
                // for ( var i = 0; i < data.length; i++ ) {
                //     selectedRows.push(this.$refs['listVehicleTable'].selectedRows[i].id)
                // }

                if( self.recalls != null || self.recalls!= ''){
                    var fields = {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                        selectedRows:selectedRows,
                        action:self.action,
                        selectedAll:self.serverParams.selectedAll,
                        recallId:self.recalls.value

                    };
                }else{
                    var fields = {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                        selectedRows:selectedRows,
                        action:self.action,
                        selectedAll:self.serverParams.selectedAll

                    };
                }


                if ( self.availabilityFromDate != null ) {
                    fields.filters.availabilityFromDate = self.availabilityFromDate;
                    fields.filters.availabilityToDate = self.availabilityToDate;
                }
                if ( self.availabilityAssetType != "") {
                    fields.filters.availabilityAssetTypeId = self.availabilityAssetType.value;
                }
                if ( self.availabilityLocation != "") {
                    fields.filters.availabilityLocationId = self.availabilityLocation.value;
                }


                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/equipment-master/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {

                            if ( self.action == "delete" ) {

                                self.action = "list";
                                $("#deleteVehicleBtn").val("Delete");

                                self.$refs.filterComponent.clearSelectAll();
                                self.loadList();
                                EventBus.$emit('clear-all-flags', false);   //hide alert of selection

                            } else if ( self.action == "export" ||  self.action == "export_queue") {

                              if ( data.code == "201" ) {
                                  alert(data.message);
                              } else {

                                  if ( self.action == "export" ) {

                                      self.excel = data.content.web;
                                      var save = document.createElement("a");
                                      save.href = self.excel;
                                      save.download = data.content.web;
                                      save.target = "_blank";

                                      document.body.appendChild(save);
                                      save.click();
                                      document.body.removeChild(save);

                                  } else {

                                      self.batchProcess = 1;
                                      self.batchNum = data.content;
                                  }

                              }

                            self.action = "list";
                            // self.loadList();

                            } else if ( self.action == "recall" ) {
                                self.submitBtnText = "Submit";
                                $("#addRecallAssetBtn").prop("disabled", false);
                                $("#cancelRecallAssetBtn").prop("disabled", false);
                                $("#recallModal").modal('hide');
                                self.action = "list";
                                self.$refs.filterComponent.clearSelectAll();
                                self.loadList();
                                EventBus.$emit('clear-all-flags', false);   //hide alert of selection
                                self.$swal({
                                    title: "",
                                    text: "Asset Added Successfully",
                                    type: "success",
                                    showCancelButton: true,
                                    confirmButtonText: "Ok",
                                    cancelButtonText: "Cancel",
                                    showCloseButton: true,
                                    showLoaderOnConfirm: true
                                }).then(result => {
                                        if (result.value) {
                                            var url = '&recallValue='+self.recalls.value+'&recallText='+self.recalls.text;
                                            self.$router.push({ name: 'RecallAssetMapper', query: { data : btoa(url) }});
                                            self.recalls = '';

                                        } else if (result.dismiss) {
                                            self.recalls = '';
                                            return;
                                        }
                                });

                            } else {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        if ( self.action == "delete" ) {
                            self.generateStatusCodeMessage(jqXHR,true,'delete-asset-list')
                        }
                        else if ( self.action == "export" ) {
                            self.generateStatusCodeMessage(jqXHR,true,'export-asset-list')
                        }
                        else if ( self.action == "recall" ) {
                            self.generateStatusCodeMessage(jqXHR,true,'recall-asset-list')
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'get-asset-list')
                        }

                    }
                });
            },
            VehicleDelete() {

                if (confirm('Are you sure that you want to delete this Asset? ')) {

                    this.action = "delete";
                    $("#deleteVehicleBtn").val("Deleting ...");

                    this.loadList();

                }

                /*var data = this.$refs['listVehicleTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listVehicleTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Asset? ')) {
                    self.loading = true;
                    $("#deleteVehicleBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/asset/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                                $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteVehicleBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }*/
            },
            syncAsset() {

                var self = this;
                self.loading = true;
                $("#syncAssetBtn").text("Syncing...");
                $("#syncAssetBtn").prop("disabled", true);

                $.ajax({
                    url: process.env.ROOT_API + "/sync-asset",
                    type: "GET",
                    // data: 'id=' + use,
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {

                        self.loading = false;
                        $("#syncAssetBtn").text("Sync");
                        $("#syncAssetBtn").prop("disabled", false);

                        if (data.status == 'success') {

                            self.$swal({
                                // title: data.content + " " ,
                                text: data.content + " Asset are Sync.",
                                type: "success",
                                confirmButtonText: "Confirm",
                            }).then(result => {
                                if (result.value) {
                                    self.loadList();
                                }
                            });
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        $("#syncAssetBtn").text("Sync");
                        $("#syncAssetBtn").prop("disabled", false);
                        self.generateStatusCodeMessage(jqXHR,true,'')

                    }
                });
            },
            openRecallModal: function(){
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/recalls/get",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.recallArr = data.content;
                            $("#recallModal").modal('show');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-recall-get')

                    }
                });
            },

            addRecallAsset() {

                var error = false;
                var self = this;
                self.errorDetails = "";
                self.action = "recall";

                if (self.recalls == null || self.recalls == '' ||!self.recalls.value) {
                    self.errorDetails = "Recall Required.";
                    error = true;
                }

                if(!error){
                    self.submitBtnText = "In Progress ...";
                    $("#addRecallAssetBtn").prop("disabled", true);
                    $("#cancelRecallAssetBtn").prop("disabled", true);
                    self.loadList();
                }

                /*var data = this.$refs['listVehicleTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listVehicleTable'].selectedRows[i].id)
                }

                var fields = [];

                fields.push({name:'ids',value:JSON.stringify(use)});
                fields.push({name:'recall_id',value:self.recalls.value});


                // if (confirm('Are you sure that you want to delete this Asset? ')) {
                    self.loading = true;
                    $("#deleteVehicleBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/recall-asset/add",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                                $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);

                            if (data.code == '200') {
                                // self.$swal('','Asset Added Successfully','success');
                                $("#recallModal").modal('hide');
                                self.loadList();
                                self.$swal({
                                    title: "",
                                    text: "Asset Added Successfully",
                                    type: "success",
                                    showCancelButton: true,
                                    confirmButtonText: "Ok",
                                    cancelButtonText: "Cancel",
                                    showCloseButton: true,
                                    showLoaderOnConfirm: true
                                }).then(result => {
                                        if (result.value) {
                                                var url = '&recallValue='+self.recalls.value+'&recallText='+self.recalls.text;
                                                self.$router.push({ name: 'RecallAssetMapper', query: { data : btoa(url) }});

                                        } else if (result.dismiss) {
                                            return;
                                        }
                                });

                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });*/
                // }
            },

            addAssetToProgram:function(){
                var self = this;

                // var data = this.$refs['listVehicleTable'].selectedRows;
                var use = [];
                // for (var i = 0; i < data.length; i++) {
                //     use.push(this.$refs['listVehicleTable'].selectedRows[i].id)
                // }

                var program = self.$route.query.pr;
                var fields = [];

                fields.push({name:'vehicles',value:JSON.stringify(use)});
                fields.push({name:'program_id',value:program});

                if (confirm('Are you sure that you want to add these Asset to Program? ')) {
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/program-asset/add",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                                $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);

                            if (data.code == '200') {
                                // self.$swal('','Asset Added Successfully','success');
                                $("#recallModal").modal('hide');
                                self.loadList();
                                self.$swal({
                                    title: "",
                                    text: "Asset Added Successfully",
                                    type: "success",
                                    showCancelButton: true,
                                    confirmButtonText: "Ok",
                                    cancelButtonText: "Cancel",
                                    showCloseButton: true,
                                    showLoaderOnConfirm: true
                                }).then(result => {
                                        if (result.value) {
                                                // var url = '&program='+program+'&recallText='+self.recalls.text;
                                                self.$router.push({ name: 'ProgramAssetMapperList', params: { id : program }});

                                        } else if (result.dismiss) {
                                            return;
                                        }
                                });

                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }

            }

        }
    };
</script>



// WEBPACK FOOTER //
// src/components/reports/EquipmentMaster.vue